// extracted by mini-css-extract-plugin
module.exports = {"container":"page-not-found_container__33Esg","button":"page-not-found_button__qRNUS","title":"page-not-found_title__tZkJn","content":"page-not-found_content__330Mu"};